import {Play} from 'lucide-react'
import { motion } from "framer-motion"

const testimonials = [
  {
    quote: "De zero a apresentação em 4 meses",
    name: "Carlos",
    role: "analista de sistemas",
    image: "https://static.lumi.new/ea/eace40cb9be734369613b6de20113a79.png",
    border: "border-blue-500",
    hasPlayIcon: true,
  },
  {
    quote: "Finalmente parei de travar em reuniões",
    name: "Mariana",
    role: "gerente de projetos",
    image: "https://static.lumi.new/26/26044f8b3036b69f96766bc3fdf71e77.png",
    border: "border-red-500",
    hasPlayIcon: false,
  },
  {
    quote: "Minha primeira viagem sozinho para NY",
    name: "Pedro",
    role: "estudante de medicina",
    image: "https://static.lumi.new/2c/2c2f4ab3497be324e75c18e806c31977.png",
    border: "border-blue-500",
    hasPlayIcon: false,
  },
]

const avatarStack = [
  "https://images.pexels.com/photos/774909/pexels-photo-774909.jpeg?auto=compress&cs=tinysrgb&w=100",
  "https://images.pexels.com/photos/1239291/pexels-photo-1239291.jpeg?auto=compress&cs=tinysrgb&w=100",
  "https://images.pexels.com/photos/1681010/pexels-photo-1681010.jpeg?auto=compress&cs=tinysrgb&w=100",
  "https://images.pexels.com/photos/733872/pexels-photo-733872.jpeg?auto=compress&cs=tinysrgb&w=100",
  "https://images.pexels.com/photos/91227/pexels-photo-91227.jpeg?auto=compress&cs=tinysrgb&w=100",
]

function SocialProofCarousel() {
  return (
    <section className="bg-gray-50 py-14 sm:py-20 px-4">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
          {testimonials.map((t, i) => (
            <motion.div
              key={t.name}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.15 }}
              className="bg-white rounded-2xl shadow-lg p-6 flex flex-col items-center text-center"
            >
              <div className={`relative w-24 h-24 rounded-full overflow-hidden border-4 ${t.border} mb-4`}>
                <img src={t.image} alt={t.name} className="w-full h-full object-cover" />
                {t.hasPlayIcon ? (
                  <div className="absolute inset-0 flex items-center justify-center bg-black/30 rounded-full">
                    <Play className="w-8 h-8 text-white fill-white" />
                  </div>
                ) : null}
              </div>
              <p className="text-gray-800 font-semibold text-lg mb-2">"{t.quote}"</p>
              <p className="text-gray-600 text-sm">
                <span className="font-bold">{t.name}</span>, {t.role}
              </p>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.3 }}
          className="flex flex-col sm:flex-row items-center justify-center gap-4"
        >
          <div className="flex -space-x-3">
            {avatarStack.map((url, i) => (
              <img
                key={i}
                src={url}
                alt="Aluno"
                className="w-10 h-10 rounded-full border-2 border-white object-cover"
              />
            ))}
          </div>
          <p className="text-gray-700 font-semibold text-lg">
            Junte-se a <span className="text-blue-600">10.000+</span> alunos transformados
          </p>
        </motion.div>
      </div>
    </section>
  )
}

export default SocialProofCarousel
